import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import 'chartjs-adapter-moment';

import '../../assets/styles/App.css';
import "@fontsource/montserrat";

export default function PlatformApplicationChart(props) {
  const canvas = useRef(null);

  const screenSize = (window.innerWidth >= 768);

  useEffect(() => {
          const config = {
              type: 'bar',
              data: {
                labels: props.labels,
                datasets: [{
                    label: 'Unqualified Applications',
                    backgroundColor: 'rgba(0, 116, 222, 1)',
                    borderColor: 'rgba(0, 116, 222, 1)',
                    data: props.unqualifiedApplications,
                    fill: false,
                    barThickness: 4,
                  }, {
                    label: 'Qualified Applications',
                    backgroundColor: 'rgba(255, 230, 1, 0.8)',
                    borderColor: 'rgba(255, 230, 1, 0.8)',
                    data: props.qualifiedApplications,
                    fill: false,
                    barThickness: 4,
                  },
                ],
              },
              options: {
                maintainAspectRatio: false,
                responsive: true,                             
                elements: {
                  point:{
                    radius: 0
                  }
                },                
                hover: {
                  mode: "nearest",
                  intersect: true,
                },
                plugins: {
                  legend: {
                    display: true,
                    position: 'top',
                    labels: {
                      padding: 30,
                      color: 'white',
                      pointStyle: 'circle',
                      usePointStyle: true,
                      }
                  },
                  title: {
                    display: false,
                    text: "Orders Chart",
                  },
                  tooltip: {
                    mode: "index",
                    intersect: false,
                  },
                },
                scales: {
                  x: 
                    {
                      stacked: true,
                      display: true,
                      type: 'time',
                      time: {
                        displayFormats: {
                            quarter: 'MMM YYYY'
                        }
                      },
                      grid: {
                        display: false,
                        color: "rgba(238, 238, 238, 0.1)",
                        zeroLineColor: "rgba(0, 0, 0, 0)",
                      },
                      ticks: {
                        color: 'white',
                        autoSkip: true,
                        maxTicksLimit: 10,
                        scaleLabel: {
                          display: false,
                          labelString: "Month",
                        },
                      },
                    },
                  y: {
                      display: true,
                      stacked: true,                                          
                      grid: {
                        display: true,
                        drawBorder: false,
                        color: "rgba(238, 238, 238, 0.1)",
                        zeroLineColor: "rgba(100, 100, 100, 0.1)",
                        zeroLineWidth: 1
                      },
                      ticks: {
                        color: 'white',
                        autoSkip: true,
                        maxTicksLimit: 6,
                        max: 40000000,
                        min: 0,
                        callback: function(value, index, values) {
                            return value / 1e6 + 'M';
                        },
                        scaleLabel: {
                          display: true,
                          fontColor: 'white',
                          labelString: "Daily platform applications",
                        },  
                      },
                    },
                },
              },
            };

            const chart = new Chart(canvas.current, config);

            return () => {
              // need cleanup because React runs useEffect callback twice in dev env
              chart.destroy();
            };

      }, [props.labels, props.qualifiedApplications, props.unqualifiedApplications]);
  return (
    <>
      <div className="w-full">
        <p className={`text-yellow text-16-19 mb-2 ${screenSize && 'px-8'}`}>{props.title}</p>
        <div className="relative h-400-px">
            <canvas ref={canvas}></canvas>
        </div>
      </div>
    </>
  );
}
